import { PayloadAction } from '@reduxjs/toolkit';

import { ICartEntry } from '@rbi-ctg/menu';
import { createAppSlice } from 'state/global-state/utils';

import { ICartState } from './cart.types';

export const initialState: ICartState = {
  cartEntries: [],
};

export const cartSlice = createAppSlice({
  name: 'cart',
  initialState,
  reducers: {
    resetCart: state => {
      state.cartEntries = [];
    },
    addCartEntry: (state, { payload }: PayloadAction<ICartEntry>) => {
      state.cartEntries.push(payload);
    },
    // used to remove single and multiple entries
    removeCartEntries: (state, { payload }: PayloadAction<Set<string>>) => {
      state.cartEntries = state.cartEntries.filter(entry => !payload.has(entry.cartId));
    },
    updateQuantity: (state, { payload }: PayloadAction<{ cartId: string; quantity: number }>) => {
      const { cartId, quantity } = payload;
      state.cartEntries = state.cartEntries.map(entry => {
        if (entry.cartId === cartId) {
          entry.quantity = quantity;
        }
        return entry;
      });
    },
  },
});
